<template>
  <div class="home" v-cloak>
    <p class="head">
      <span class="name">{{user_name}}</span>
      <span class="id">{{person_id}}</span>
      <span class="quit iconfont icon-tuichu1" @click="toLogin()">退出</span>
    </p>



    <ul class="info" v-if="examInfo.length>0" >
      <li  v-for="(v,i) in examInfo" :key="i">
        <span class="name" >{{v.exam_name}}</span>
        <span class="level pc" :style="v.exam_level | levelFilter">{{v.exam_level}}</span>
        <span class="time pc" >{{v.exam_start_time | timeFilter}}---{{v.exam_end_time | timeFilter}}</span>
        <span class="score" :style="v.score | waitingFilter">{{v.score || '--'}}
          <em v-show="v.score && v.score!='阅卷中'">分</em>
        </span>
        <span class="btn">
          <button v-show="examJudge(v)" @click="enterExam(v)">进入考试</button>
        </span>
      </li>
    </ul>
    <ul class="info" v-show="examInfo.length===0" v-cloak>
       <li class="mob" > 暂时没有任何考试数据...
         <button class="official"  @click="officialWeb()" >进入官网</button>
       </li>
    </ul>
    
  </div>
</template>

<script>
export default {
  name: 'Home',
  components: {
    
  },
  data() {
    return{
      that: this,
      user_name:'',
      person_id:'',
      start:'',
      end:'',
      examInfo:[],
    }
  },
  async mounted(){
    // this.user_name=sessionStorage.getItem('user_name')
    // this.person_id=sessionStorage.getItem('person_id')
    // // console.log( this.person_id=sessionStorage.getItem('person_id'));
    // var id_length=this.person_id.length
    // this.person_id=this.person_id.slice(0,3)+'***'+this.person_id.substring(id_length-4,id_length)


    var history=await this.$http.post('http://exam.ah1d.com/api/answer_post/history',{
       token:sessionStorage.getItem('token')
    })
    console.log(history.data)

    var pending=await this.$http.post('http://exam.ah1d.com/api/exam/index',{
    // var pending=await this.$http.get('http://localhost:3000/info',{
       token:sessionStorage.getItem('token')
    })
    console.log(pending,pending.data);

    this.examInfo=[...pending.data.data,...history.data.data]
    this.examInfo=[]
    console.log(this.examInfo);
  },
  created() {
    this.user_name=sessionStorage.getItem('user_name')
    this.person_id=sessionStorage.getItem('person_id')
    // console.log( this.person_id=sessionStorage.getItem('person_id'));
    var id_length=this.person_id.length
    this.person_id=this.person_id.slice(0,3)+'***'+this.person_id.substring(id_length-4,id_length)
    
  },
  methods:{
    officialWeb(){
      // window.location.href="http://www.cidasc.org/"
      var tempwindow=window.open('_blank');
      tempwindow.location="http://www.cidasc.org/"
    },
    
    
    toLogin(){
      sessionStorage.clear();
      this.$router.push('/login')
    },
    enterExam(v){
      var now=Date.parse(new Date())
      var startTime=v.exam_start_time *1000
      if(now<startTime){
        alert('未到考试时间，请等候')
        return
      }else{
        // alert('开始考试')
        this.$router.push('/notice')
      }
    },


    scoreFilter(v){
      console.log(v);
      if(v==='阅卷中'){
        return false
      }
      if(parseInt(v)>0){
        console.log('大于零');
        return false
      }
      console.log('等于零');
      return true
    },

    timeJudge(endTime,time_len){
      sessionStorage.setItem('timeDiff',time_len/60)
      var now=Date.parse(new Date())
      if(now>endTime*1000){
        console.log('已结束');
        return false
      }
      console.log('还未结束');
      return true 
    },

    examJudge(v){
      // console.log(v.people_exam_score,v.exam_end_time,v.exam_time_len);
      // console.log(this.formatDate(v.exam_start_time));
      return this.scoreFilter(v.score) && this.timeJudge(v.exam_end_time,v.exam_time_len)
    },

    formatDate(date){
        var date = new Date(date*1000);
        // console.log(date);
        var YY = date.getFullYear() + '-';
        var MM = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
        var DD = (date.getDate() < 10 ? '0' + (date.getDate()) : date.getDate());
        var hh = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':';
        var mm = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':';
        var ss = (date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds());
        return YY + MM + DD +" "+hh + mm + ss;
    }
    
  },
  filters:{
    timeFilter(v){
      function formatDate(date){
        var date = new Date(date*1000);
        // console.log(date);
        var YY = date.getFullYear() + '-';
        var MM = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
        var DD = (date.getDate() < 10 ? '0' + (date.getDate()) : date.getDate());
        var hh = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':';
        var mm = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':';
        var ss = (date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds());
        return YY + MM + DD +" "+hh + mm + ss;
      }
      return formatDate(v)
    },
    levelFilter(v){
      switch(v){
        case'初级':
          return 'color:#01c26f'
        case '中级':
          return 'color:#ffa638'
        case '高级':
          return 'color:#ff706c'
      }
    },
    
    waitingFilter(score){
      if(score && score!='阅卷中'){
        return 
      }else{
        return "color:red"
      }
    },
  },

}
</script>



<style scoped>
[v-cloak]{ 
  display:none;
}

.home{
  font-size: 1.2rem;
}
.head{
  background: #fff;
  color: #444;
  height: 3rem;
  line-height: 3rem;
  margin-bottom: 2rem;
  width: 62.5%;
  margin: 0 auto;
  position: relative;
}
.head span.name{
  margin-right: 2rem;
}
.head span.quit{
  position: absolute;
  right: 1rem;
}
.head span.quit:hover{
  cursor: pointer;
}

em{
  font-style: normal;
}


.info{
  width: 62.5%;
  background:#fff;
  margin: 2rem auto;
  padding-top: 1px;
}
.info li{
  border-bottom:1px dashed #777;
  height: 3.5rem;
  line-height: 3.5rem;
  /* text-align:center; */
  /* margin: 1.5rem; */
  /* position: relative; */
  /* vertical-align: middle; */
}
.info li span{
   margin:0 1rem;
  color: #555;
  display: inline-block;
}
.info li span.name{
  width: 19rem;
  /* height: 100%; */
  white-space:nowrap;
  overflow:hidden;
  text-overflow:ellipsis;
  vertical-align: bottom;
}
.info li span.level{
  width: 5rem;
}
.info li span.time{
  width: 28rem;
}
.info li span.score{
  width: 5rem;
}
.info li span.btn{
    width: 5rem;
    /* min-width: 57px; */
    /* height: 20%; */
    /* border: 1px solid red; */
}

.info li button{
  display: inline-block;
  height: 2rem;
  width: 5rem;
  min-width: 57px;
  background: #4f93fe;
  color: #fff;
  border: none;
  outline: none;
  border-radius: 0.2rem;
  margin:0;
}
.info li button:hover{
  cursor: pointer;
}
.info .official{
  margin-right:1rem;
  width:12rem;
  height:3.2rem;
  font-size: 1.2rem;
  float:right;
}
@media screen and (max-width:720px){
  .head,.info{
    width: 100%;
  }
  .head{
    height: 13rem;
    line-height: 13rem;
    font-size: 5.5rem;
  }
  .info li{
    height: 12.5rem;
    line-height: 12.5rem;
    font-size: 5.2rem;
    /* text-align:center; */
  }
  .info li span{
    margin: 0 3rem;
  }
  .info li span.pc{
    display: none;
  }

  .info li span.name{
    width: 70rem;
    font-size: 4rem;
  }
  .info li span.score{
    width:12rem;
    font-size: 4rem;
  }
  .info li button{
    height: 8rem;
    width: 26rem;
    
  }
  button{
    margin: 0;
  }
  .info{
    position: relative;
  }
  .info .official{
    width: 27rem;
    height: 8.2rem;
    position: absolute;
    right: .5rem;
    transform: translateY(-50%);
    top: 50%;
    font-size: 5.2rem;
  }


}
</style>
